import * as React from 'react';
import * as styles from './Guide.css';
import { inject, observer } from 'mobx-react';
import { Store } from '../../stores';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IAGroup } from '../../../group/Group';
import { IAIcon } from '../../../icon/Icon';

export interface IProps {
  store?: Store;
}

export interface IState {
  tipIndex: number;
  hideQuickGuide: boolean;
  hideTips: boolean;
}

@inject('store')
@observer
export class Guide extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      tipIndex: Math.floor(Math.random() * 4) + 1,
      hideQuickGuide: true,
      hideTips: true
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private getTipHeadline(): string {
    switch (this.state.tipIndex) {
      case 1:
        return this.localizationService.strings.Composer_Tip1Headline;
      case 2:
        return this.localizationService.strings.Composer_Tip2Headline;
      case 3:
        return this.localizationService.strings.Composer_Tip3Headline;
      case 4:
        return this.localizationService.strings.Composer_Tip4Headline;
      case 5:
        return this.localizationService.strings.Composer_Tip5Headline;
    }
  }

  private getTip(): string {
    switch (this.state.tipIndex) {
      case 1:
        return this.localizationService.strings.Composer_Tip1;
      case 2:
        return this.localizationService.strings.Composer_Tip2;
      case 3:
        return this.localizationService.strings.Composer_Tip3;
      case 4:
        return this.localizationService.strings.Composer_Tip4;
      case 5:
        return this.localizationService.strings.Composer_Tip5;
    }
  }

  public render(): JSX.Element {
    const titleStyle: React.CSSProperties = {
      backgroundColor: "transparent",
      borderColor: "#333333",
      paddingLeft: 10,
      borderBottom: "none",
      fontSize: 12
    };
    const contentStyle: React.CSSProperties = {
      padding: "0 10px",
      marginTop: -10,
      position: "relative",
      float: "left"
    };
    return (
      <div className={styles.IA_guide}>
        <h1 style={{ fontSize: 14, width: "80%", float: "left", marginLeft: 10, fontWeight: "normal", paddingTop: 0 }}>{this.localizationService.strings.Composer_QuickGuide}</h1>
        <IAIcon
          url={this.state.hideQuickGuide ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg"}
          size={18}
          color={"#333333"}
          style={{
            float: "right",
            clear: "none",
            marginTop: 10,
            marginRight: 11
          }}
          onClick={() => {
            this.setState({hideQuickGuide: !this.state.hideQuickGuide})
            this.forceUpdate();
          }}
        />
        { !this.state.hideQuickGuide &&
          <div>
            <IAGroup
              label={this.localizationService.strings.Composer_TabCompose}
              collapsed={this.props.store.selectedComposerTab !== "content"}
              titleStyle={titleStyle}
              contentStyle={{
                marginBottom: 10,
                ...contentStyle
              }}
            >
              <p>{this.localizationService.strings.Composer_ContentInfo}</p>
              <img src="https://intraactivestorage.blob.core.windows.net/cdn/SDK Images/composer-toolbox.jpg" width="100%" />
            </IAGroup>
            <IAGroup
              label={this.localizationService.strings.Composer_TabSettings}
              collapsed={this.props.store.selectedComposerTab !== "settings"}
              titleStyle={titleStyle}
              contentStyle={contentStyle}
            >
              <p>{this.localizationService.strings.Composer_SettingsInfo}</p>
              <ul>
                <li>{this.localizationService.strings.Composer_SettingsInfoBullet1}</li>
                <li>{this.localizationService.strings.Composer_SettingsInfoBullet2}</li>
                <li>{this.localizationService.strings.Composer_SettingsInfoBullet3}</li>
                <li>{this.localizationService.strings.Composer_SettingsInfoBullet4}</li>
              </ul>
            </IAGroup>
            <IAGroup
              label={this.localizationService.strings.Composer_TabPreview}
              collapsed={this.props.store.selectedComposerTab !== "preview"}
              titleStyle={titleStyle}
              contentStyle={contentStyle}
            >
              <p>{this.localizationService.strings.Composer_PreviewInfo}</p>
            </IAGroup>
          </div>
        }
        <div className={styles.IA_tips}>
          <h1 style={{ fontSize: 14, width: "80%", float: "left", marginLeft: 10, fontWeight: "normal", paddingTop: 0 }}>{this.localizationService.strings.Composer_Tips}</h1>
          <IAIcon
            url={this.state.hideTips ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg"}
            size={18}
            color={"#333333"}
            style={{
              float: "right",
              clear: "none",
              marginTop: 10,
              marginRight: 11
            }}
            onClick={() => {
              this.setState({hideTips: !this.state.hideTips})
              this.forceUpdate();
            }}
          />
          {!this.state.hideTips &&
            <div>
              <div className={styles.IA_tip}>
                <img src={`https://intraactivestorage.blob.core.windows.net/cdn/SDK Images/composer-tip-${this.state.tipIndex}.jpg`} width="240" height="135" />
                <div
                  style={{
                    fontSize: 16,
                    float: "left",
                    width: "100%",
                    marginBottom: 5,
                    marginTop: 4
                  }}
                >
                  <span style={{ fontWeight: "bold", marginRight: 8 }}>{`#${this.state.tipIndex}`}</span><span>{this.getTipHeadline()}</span>
                </div>
                <div
                  style={{
                    width: "100%"
                  }}
                >
                  {this.getTip()}
                </div>
              </div>
              <div className={styles.IA_tipsNavigation}>
                <IAIcon
                  url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Left/SVG/ic_fluent_chevron_left_48_regular.svg"
                  size={18}
                  color={"#333333"}
                  style={{
                    float: "left",
                    opacity: this.state.tipIndex > 1 ? 1 : 0.5
                  }}
                  onClick={this.state.tipIndex > 1 ? () => {
                    this.setState({ tipIndex: this.state.tipIndex - 1 });
                  } : undefined}
                />
                <div style={{
                  width: 50,
                  textAlign: "center",
                  float: "left"
                }}>
                  {`${this.state.tipIndex} / 5`}
                </div>
                <IAIcon
                  url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Right/SVG/ic_fluent_chevron_right_48_regular.svg"
                  size={18}
                  color={"#333333"}
                  style={{
                    float: "left",
                    opacity: this.state.tipIndex < 5 ? 1 : 0.5
                  }}
                  onClick={this.state.tipIndex < 5 ? () => {
                    this.setState({ tipIndex: this.state.tipIndex + 1 });
                  } : undefined}
                />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}